import '@fortawesome/fontawesome-free/css/all.css';
import Vue from 'vue';
import Vuetify, {
	VAutocomplete,
	VBtn,
	VCard,
	VContainer,
	VFlex,
	VForm,
	VLayout,
	VList,
	VParallax,
	VRow,
	VSelect,
	VTab,
	VDataTable,
	VToolbar
} from 'vuetify/lib';

Vue.use(Vuetify);

const vuetify = new Vuetify({
	components: {
		VAutocomplete,
		VBtn,
		VCard,
		VContainer,
		VFlex,
		VForm,
		VLayout,
		VList,
		VParallax,
		VRow,
		VSelect,
		VTab,
		VDataTable,
		VToolbar
	},
	icons: {
		iconfont: 'fa'
	},
	theme: {
		themes: {
			light: {
				primary: '#1E315B',
				secondary: '#55678E',
				accent: '#FD773E',
				error: '#EF500D',
				info: '#2196F3',
				success: '#d5e5e5',
				warning: '#FFC107'
				// anchor: '#FFC107'
			},
			dark: {
				primary: '#1E315B',
				secondary: '#55678E',
				accent: '#d07633',
				error: '#EF500D',
				info: '#2196F3',
				success: '#d5e5e5',
				warning: '#FFC107'
				// anchor: '#FFC107'
			}
		}
	}
});
export default vuetify;
